import React from "react";
import { Breadcrumb, Button, Col, FloatButton, Form, Input, Row, Select, Spin, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { POST_API, POST_CATCH, getToken, titleWeb } from "../../services/hello-api";
import { IoArrowBack } from "react-icons/io5";
import ReactInputMask from "react-input-mask";

import { IoLogoWhatsapp, IoMailOutline } from 'react-icons/io5';

class FormandoForm extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        _screen: true,
        _params: window.location.href.split('/'),
        _type: this.props.type === 'add' ? 'Adicionar' : 'Editar',
        defaultValue: null,
        doc: false,
        fileList: [],
        filters: { INSTITUTION_ID: [], COURSE_ID: [], GENDER_ID: [], MARITAL_STATUS_ID: [], TYPE_CREDENTIAL_ID: [], CLASS_ID: [] }
    }

    back = this.props.url;

    componentDidMount = () => {
        titleWeb('Formandos')
        this.onFilters()
        if (this.props.type === 'add') {
            this.setState({_screen: false})
        } else if (this.props.type === 'edit') {
            this.onView()
        }
    }

    onFilters = () => {
        POST_API('/graduate/filters.php', { token: getToken() }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({filters: res.data})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    onChangeFilter = (v) => {
        POST_API('/graduate/filters.php', { token: getToken(), INSTITUTION_ID: v }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({filters: { ...this.state.filters, COURSE_ID: res.data.COURSE_ID, CLASS_ID: res.data.CLASS_ID }})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    onChangeFilterCourse = (v) => {
        POST_API('/graduate/filters.php', { token: getToken(), COURSE_ID: v }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({filters: { ...this.state.filters, CLASS_ID: res.data.CLASS_ID }})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    onView = async () => {
        var filter = {ID: this.state._params[6]}
        POST_API('/graduate/search.php', { token: getToken(), type: 'view', filter: JSON.stringify(filter) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({defaultValue: res.data})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_screen: false}))
    }

    onSend = (values) => {
        this.setState({_loading: true})
        if (this.props.account) values.ACCOUNT_ID = this.state._params[6]
        POST_API('/graduate/save.php', { token: getToken(), type: this.props.type, master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
                this.setState({_navigate: true})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_loading: false}))
    }

    render = () => {

        const routes = this.props.bread

        if (this.state._navigate) {
            return (<Navigate to={this.back} />)
        }

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                    <Link to={this.back}><FloatButton className="float-button back" icon={<IoArrowBack color="#FFF" size={25} />}/></Link>
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={routes} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Link to={this.back}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]} align={'bottom'}>
                        { this.state._screen ? <Col span={24}><center><Spin /></center></Col> : (
                            <Col span={24}>
                                <Form layout="vertical" className={`admin-form`} onFinish={this.onSend} initialValues={this.state.defaultValue}>
                                    <Form.Item hidden name="ID">
                                        <Input />
                                    </Form.Item>
                                    <Form.Item hidden name="CREDENTIAL_ID">
                                        <Input />
                                    </Form.Item>
                                    <Row gutter={[16,0]}>
                                        <Col md={12} xs={24}>
                                            <Form.Item label="Instituição" name="INSTITUTION_ID" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select onChange={this.onChangeFilter}>
                                                    { this.state.filters.INSTITUTION_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={8} xs={12}>
                                            <Form.Item label="Curso" name="COURSE_ID" class="profile-form-item">
                                                <Select>
                                                    { this.state.filters.COURSE_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={12}>
                                            <Form.Item label="Turma" name="CLASS_ID" class="profile-form-item">
                                                <Select>
                                                    { this.state.filters.CLASS_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.SEMESTER_NAME} / {v.YEAR}</Select.Option> ) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={14} xs={24}>
                                            <Form.Item label="Nome Completo" name="CREDENTIAL_NAME" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={6} xs={24}>
                                            <Form.Item label="E-mail" name="CREDENTIAL_EMAIL" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}, {type: 'email', message: 'E-mail inválido'}]}>
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={12}>
                                            <Form.Item label="Tipo Formando" name="TYPE_CREDENTIAL_ID" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select>
                                                    { this.state.filters.TYPE_CREDENTIAL_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={12}>
                                            <Form.Item label="Data Nascimento" name="BIRTH_DATE" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input type="date" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <Form.Item label="Gênero" name="GENDER_ID" class="profile-form-item">
                                                <Select>
                                                    { this.state.filters.GENDER_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <Form.Item label="Estado Cívil" name="MARITAL_STATUS_ID" class="profile-form-item">
                                                <Select>
                                                    { this.state.filters.MARITAL_STATUS_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={10}>
                                            <Form.Item label="CPF" name="CPF" class="profile-form-item">
                                                <ReactInputMask mask={'999.999.999-99'} className="ant-input css-dev-only-do-not-override-nnuwmp css-nnuwmp" />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={8}>
                                            <Form.Item label="RG" name="RG" class="profile-form-item">
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={6}>
                                            <Form.Item label="Emissor" name="RG_ISSUER" class="profile-form-item">
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={3} xs={8}>
                                            <Form.Item label="CEP" name="ADDRESS_CEP" class="profile-form-item">
                                                <ReactInputMask mask={'99999-999'} className="ant-input css-dev-only-do-not-override-nnuwmp css-nnuwmp" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={16} md={6}>
                                            <Form.Item label="Endereço" name="ADDRESS_STREET">
                                                <Input type='text' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={6} md={3}>
                                            <Form.Item label="Número" name="ADDRESS_NUMBER">
                                                <Input type='text' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={18} md={5}>
                                            <Form.Item label="Bairro" name="ADDRESS_DISTRICT">
                                                <Input type='text' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={20} md={5}>
                                            <Form.Item label="Cidade" name="ADDRESS_CITY">
                                                <Input type='text' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={4} md={2}>
                                            <Form.Item label="UF" name="ADDRESS_STATE">
                                                <Input type='text' maxLength={2} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={14}>
                                            <Form.Item label="Outro e-mail" name="SOCIAL_MEDIA_EMAIL">
                                                <Input addonBefore={<IoMailOutline />} type='email' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} md={5}>
                                            <Form.Item label="Whatsapp" name="SOCIAL_MEDIA_WHATSAPP">
                                                <span class="ant-input-group-wrapper css-dev-only-do-not-override-nnuwmp">
                                                    <span class="ant-input-wrapper ant-input-group css-dev-only-do-not-override-nnuwmp">
                                                        <span class="ant-input-group-addon"><IoLogoWhatsapp /></span>
                                                        <ReactInputMask className="ant-input css-dev-only-do-not-override-nnuwmp css-nnuwmp" mask={'+55 (99) 99999-9999'} value={this.state.defaultValue?.SOCIAL_MEDIA_WHATSAPP} />
                                                    </span>
                                                </span>
                                            </Form.Item>
                                        </Col>
                                        
                                        <Col xs={12} md={5}>
                                            <Form.Item label="Outro Telefone" name="SOCIAL_MEDIA_PHONE">
                                                <span class="ant-input-group-wrapper css-dev-only-do-not-override-nnuwmp">
                                                    <span class="ant-input-wrapper ant-input-group css-dev-only-do-not-override-nnuwmp">
                                                        <span class="ant-input-group-addon"><IoLogoWhatsapp /></span>
                                                        <ReactInputMask className="ant-input css-dev-only-do-not-override-nnuwmp css-nnuwmp" mask={'+55 (99) 99999-9999'} value={this.state.defaultValue?.SOCIAL_MEDIA_PHONE} />
                                                    </span>
                                                </span>
                                            </Form.Item>
                                        </Col>
                                        {/* <Col xs={24} md={6}>
                                            <Form.Item label="Instagram" name="SOCIAL_MEDIA_INSTAGRAM">
                                                <Input addonBefore={<IoLogoInstagram />} type='url' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <Form.Item label="Facebook" name="SOCIAL_MEDIA_FACEBOOK">
                                                <Input addonBefore={<IoLogoFacebook />} type='url' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <Form.Item label="Twitter" name="SOCIAL_MEDIA_TWITTER">
                                                <Input addonBefore={<IoLogoTwitter />} type='url' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <Form.Item label="LinkedIn" name="SOCIAL_MEDIA_LINKEDIN">
                                                <Input addonBefore={<IoLogoLinkedin />} type='url' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <Form.Item label="Youtube" name="SOCIAL_MEDIA_YOUTUBE">
                                                <Input addonBefore={<IoLogoYoutube />} type='url' />
                                            </Form.Item>
                                        </Col> */}
                                        <Col span={24}>
                                            <Button loading={this.state._loading} htmlType="submit" type="primary" shape="round" style={{float: 'right'}}>Salvar</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        )

    }

}

export default FormandoForm;